import { useTenantInMarketStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";

const useTenantInMarketDelete = (): (id: number) => Promise<void> => {
    const tenantInMarketStore = useTenantInMarketStore()

    return async (id: number): Promise<void> => {
        try {
            await tenantInMarketStore.deleteTenantInMarket(id);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useTenantInMarketDelete;